// Feature: M004-F0654 B3 (docs/design/M004-F0654-Organisations-Page-Org-Admin-Scope.md)
//
// Visibility of the organisations page's global actions, read from the
// caller's OWN system-permission map (Core GET /api/users/me/system-permissions,
// loaded with userRemovalPolicy.loadMySystemPermissions). Each control follows
// the exact capability Core's route asserts (Core src/routes/organisation.routes.ts):
//   POST   /organisations      requireSystemPermission('organisation_create')     -> Add Organisation
//   PUT    /organisations/:id  requireSystemPermission('organisation_update_all') -> Edit
//   DELETE /organisations/:id  requireSystemPermission('organisation_delete')     -> Delete
// No role name is read. Fail closed: anything other than a literal `true`
// (map still loading, read failed, key absent) hides the control. Presentation
// only; Core's refusal stays the authority.

export const ORGANISATION_CREATE_CAPABILITY = 'organisation_create';
export const ORGANISATION_UPDATE_ALL_CAPABILITY = 'organisation_update_all';
export const ORGANISATION_DELETE_CAPABILITY = 'organisation_delete';

export const organisationActionsFor = (systemPermissions) => ({
  canCreate: systemPermissions?.[ORGANISATION_CREATE_CAPABILITY] === true,
  canEdit: systemPermissions?.[ORGANISATION_UPDATE_ALL_CAPABILITY] === true,
  canDelete: systemPermissions?.[ORGANISATION_DELETE_CAPABILITY] === true,
});
